module.exports = __webpack_public_path__ + "close-button-circle.c7aba3b0ec86db955b20779ad2b7b305.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-button-circle.svg
// module id = 1131
// module chunks = 0